module.exports = __webpack_public_path__ + "img/thq_slide_2.de657231.jpg";